import * as React from "react";
import {none, option, Option} from "ts-option";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router";
import FormGroup from "../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import Input from "../../hiberUiKit/src/atoms/Input/Input";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {isDefined, notifyBugsnagAndShowToast} from "../../utils/Utils";
import * as queryString from "query-string";
import {api} from "../../api/api";
import * as validator from "validator";
import "./revolutAuthorization.scss";
import Toast from "../helper/Toast";
import Routes from "../../navigation/route/Route";

const logo = require('../../../resources/hiber/img/dg-logo-big-green.png');

interface State {
	code: Option<string>,
	clientId: Option<string>,
	loading: boolean,
	error: Option<string>
}

type Props = RouteComponentProps<{}>;

class RevolutAuthorization extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		const code = queryString.parse(props.location.search)["code"] as string;
		this.state = {
			clientId: none,
			code: isDefined(code) ? option(code) : none,
			loading: false,
			error: none,
		};
	}

	render() {
		return (
			<div className={"c-revolutauth-page"}>
				<img src={logo} className={"c-revolutauth-page_content_logo"}/>
				<h3 className="c-revolutauth-page_content_header">Revolut Authorization</h3>
				<div className="c-revolutauth-page_content_form">
					<FormGroup label={"Code"}>
						<Input type={"text"}
							   disabled
							   value={this.state.code.getOrElse("")}/>
					</FormGroup>
					<FormGroup label={"Client id"}>
						<Input type={"text"}
							   onChange={evt => this.setState({clientId: option(evt.target.value)})}
							   value={this.state.clientId.getOrElse("")}/>
					</FormGroup>
					<div className={"c-revolutauth-page_content_form_error"}>
						{this.state.error.isDefined &&
						<span>{this.state.error.get}</span>}
					</div>
					<div className={"c-revolutauth-page_content_form_button"}>
						<ButtonPrimary label={"Submit"}
									   onClick={() => this.onSubmit()}
									   isLoading={this.state.loading}/>
					</div>
				</div>
			</div>
		)
	}

	onSubmit(): void {
		const error = this.validateForm();
		this.setState({loading: error.isEmpty, error});
		if (error.isEmpty) {
			const code = this.state.code.get;
			const clientId = this.state.clientId.get;
			api.instance.revolutAuthApi.revolutAuth(code, clientId)
				.then(() => {
					Toast.success('Authorization successful');
					this.props.history.push(Routes.LeadsList);
				})
				.catch(err => {
					this.setState({loading: false});
					return notifyBugsnagAndShowToast(err, 'Payments authorization error')
				})
		}
	}

	private validateForm(): Option<string> {
		const code = this.state.code.getOrElse("");
		const clientId = this.state.clientId.getOrElse("");
		if (validator.isEmpty(clientId))
			return option("Please provide client ID");
		else if (validator.isEmpty(code))
			return option("Code cannot be empty");
		else
			return none;
	}
}

export default withRouter(RevolutAuthorization);